import React, { useEffect, useState } from "react";
import {GreenButton, BlueButton, RedButton} from '../components/MyButton';

import s from './schools.module.css';
import {getData, postData} from '../middleware/apiMiddleware';
import { useSearchParams, useNavigate, useParams, Link } from "react-router-dom";

export default function Schools() {
	const navigate = useNavigate();
	
	const [searchParams, setSearchParams] = useSearchParams();
	const [schoolsData, setSchoolsData] = useState([]);
	const [newSchoolName, setNewSchoolName] = useState("");
	
	const fetchData = async () => {
		let page = searchParams.get("page") || 1;
		let limit = searchParams.get("limit") || 100;
		
		let myParam = {page, limit};
		
		let res = await getData('schoolApi/listSchools?' + (new URLSearchParams(myParam)).toString(), navigate);
		setSchoolsData(res.data);
	}
	
	
	useEffect(() => {
		fetchData();
	}, []);
	
	const createNewSchoolName = async () => {
		let obj = { name:newSchoolName }
		
		await postData("schoolApi/createSchool", obj, navigate); 
		fetchData();
	}
	
	const enableSchool = async (orgId, index) => {
		let obj = { orgId }
		
		await postData("schoolApi/enableSchool", obj, navigate); 
		schoolsData[index].isEnabled = true;
		setSchoolsData([...schoolsData])
	}
	
	const disableSchool = async (orgId, index) => {
		let obj = { orgId }
		
		await postData("schoolApi/disableSchool", obj, navigate); 
		schoolsData[index].isEnabled = false;
		setSchoolsData([...schoolsData])
	}
	
	
	return (<div style={{margin:"20px"}}>
		<div className={s.header}>Schools</div>

		<div className={s.paramHolder}>
			<div style={{display:"flex", borderBottom:"1px solid #4b3f1b"}}>
				<div style={{display:"flex", padding:"10px 0 0 0"}}>
					<div className={s.nonClickableTitle}>
						<span>New School</span>
					</div>
					<div style={{fontWeight:"bold"}}>:</div>		
				</div>
				<div className={s.itemHolder}>
					<input value={newSchoolName} onChange={(e)=>{
						setNewSchoolName(e.target.value);
					}} />
					<div className={(newSchoolName) ? s.btnActive : s.btnInactive} onClick={createNewSchoolName}>
						create
					</div>
				</div>
			</div>
		</div>
		
		<div>
		{
			schoolsData.map((d, indexD) => (<div style={(indexD % 2 == 1) ? {background:"#E0E0E0"}:{background:"white"}}>
			
				<div className={s.schoolData}>
					<div style={{margin:"auto 10px auto 0"}}>
						{
							(d.isEnabled == 1) && (<BlueButton isEnabled={d.isEnabled} clickedAction={()=>disableSchool(d.orgId, indexD)} bText={"Status: Enable"} />)
						}
						{
							(d.isEnabled == 0) && (<RedButton isEnabled={!d.isEnabled} clickedAction={()=>enableSchool(d.orgId, indexD)} bText={"Status:Disable"} />)
						}
					</div>
					<div style={{width:"50px"}}>{d.orgId}</div>
					<div style={{width:"500px"}}>
						<div>{d.name}</div>
						<div style={{fontSize:"12px"}}>{d.nameEn} {d.nameHk}</div>
						
					</div>
					<div style={{width:"50px"}}>{d.userCnt}</div>
					
					
						<Link style={{width:"60px"}} className={s.btnLitActive} to={`/school/${d.orgId}`} target="_blank" rel="noopener noreferrer">
							View
						</Link>
					
				</div>
			</div>))
		}
		</div>
	</div>);
}